package co.gul.ui.theme

import org.jetbrains.compose.web.css.px

object Spacing {
    val xs = 4.px
    val sm = 8.px
    val md = 16.px
    val lg = 24.px
    val xl = 32.px
    val xxl = 48.px
    val xxxl = 64.px
}